import React from 'react'
import ReactDOM from 'react-dom/client'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import '@petz/ds-badge/dist/index.css'
import '@petz/ds-icon/dist/index.css'
import '@petz/ds-tokens/petz/index.css'
import '@petz/ds-spinner/dist/index.css'
import '@petz/ds-skeleton/dist/index.css'
import '@petz/ds-card/dist/index.css'
import '@petz/ds-carousel/dist/index.css'

import { CustomBrandContainer } from './CustomBrandContainer'
import { CustomBrandPage } from './Components/CustomBrandPage'

let timeoutToAttach

const attachToPage = () => {
  timeoutToAttach = setTimeout(() => {
    const elementToAttach = document.getElementById('ecomCustomBrandContainer') as HTMLElement
    if (elementToAttach) {
      clearTimeout(timeoutToAttach)
      const root = ReactDOM.createRoot(document.getElementById('ecomCustomBrandContainer') as HTMLElement)
      root.render(
        <React.StrictMode>
          <CustomBrandPage>
            <CustomBrandContainer />
          </CustomBrandPage>
        </React.StrictMode>
      )
    } else {
      clearTimeout(timeoutToAttach)
      attachToPage()
    }
  }, 100)
}

attachToPage()
